import { apiService } from "../../services/apiService";
import { apiServiceConstants } from "../../constants/";
import { utilService } from "../../services";
import {
  AddFavoutiteModel,
  FavoriteListModal,
  FavoriteResultModal,
  ResultDataModal,
} from "./OnCallLookUpFavoriteModal";

/**
 * Oncall Look Up Favorite api call
 */
const getOnCallFavoritesList = async (
  params: object,
  selectedNetwork?: any
): Promise<FavoriteResultModal> => {
  try {
    const resApi = await apiService.apiCall(
      `user/labellookups/?reg_code=${utilService.getNetwork()}&n2n_network=${selectedNetwork}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    );

    const response = resApi as FavoriteListModal;
    const returnResult = setFavResult(response);

    return {
      isSuccess: true,
      status: response.status,
      message: response.message,
      favData: returnResult,
    };
  } catch (error: any) {
    return {
      isSuccess: false,
      message: error.message,
      status: error.status ?? 500,
    };
  }
};
/**
 * Oncall Look Up Favorite api call to add new favourite  item
 */
const addOnCallFavoritesList = async (
  params: object
): Promise<AddFavoutiteModel> => {
  const resApi = await apiService
    .apiCall(
      `user/labellookups/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as AddFavoutiteModel;
      const result: FavoriteResultModal = {
        isSuccess: true,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: AddFavoutiteModel = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

/**
 * Oncall Look Up Favorite api call to remove favourite  item
 */
const removeOnCallFavoritesListItem = async (params: any,selectedNetwork:string): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `user/labellookups/${params.id}/?reg_code=${utilService.getNetwork()}&n2n_network=${selectedNetwork}`,
      params,
      apiServiceConstants.DELETE,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as AddFavoutiteModel;
      const result: FavoriteResultModal = {
        isSuccess: true,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: AddFavoutiteModel = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

/**
 * Oncall Look Up Favorite api call to edit favourite  item
 */
const editOnCallFavoritesListItem = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `user/labellookups/${
        params.id
      }/?reg_code=${utilService.getNetwork()}&user=${params.user}`,
      params,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as AddFavoutiteModel;
      const result: FavoriteResultModal = {
        isSuccess: true,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: AddFavoutiteModel = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

/**
 * OnCall look up
 * @param response
 */
const setFavResult = (response: FavoriteListModal): ResultDataModal => {
  if (!response.result || response?.result.length === 0) {
    return {
      next: null,
      data: []
    };
  }

  const resultData = response.result?.[0];
  return {
    next: resultData.next ?? null,
    data: resultData.data ?? []
  };
};
export const OnCallLookUpService = {
  getOnCallFavoritesList,
  addOnCallFavoritesList,
  removeOnCallFavoritesListItem,
  editOnCallFavoritesListItem,
};
